import { SafeValue } from '@angular/platform-browser';

type SecureInputValue = {
  changingThisBreaksApplicationSecurity: string;
};

export function unwrapSafeValue(value: string | SafeValue): string {
  if (typeof value === 'string') {
    return value;
  }

  const safeHtml: SecureInputValue = value as SecureInputValue;
  if (safeHtml.changingThisBreaksApplicationSecurity) {
    return safeHtml.changingThisBreaksApplicationSecurity;
  }

  throw new Error(`Failed to unwrap safe value ${JSON.stringify(value)}`);
}
